import React, { lazy, Suspense } from "react";
import { Switch, Route } from "wouter";
import constants from "../app/constants";

// Lazy-load route modules into a single "lazy-modules" chunk
// All chunks are pre-cached by the service worker for offline access
const DriverSafetyModuleView = lazy(() => import("../app/modules/driverSafety/ui/main"));
const PasswordChangeModuleView = lazy(() => import("../app/modules/core/settings/passwordChange/ui/main"));
const MessagingModuleView = lazy(() => import("../app/modules/messaging/ui/main"));
const MessageViewModuleView = lazy(() => import("../app/modules/messaging/ui/view"));
const EldMalfunctionsView = lazy(() => import("../app/modules/hos/eldMalfunctions/ui/main"));
const EventsModuleView = lazy(() => import("../app/modules/core/notifications/events/ui/main"));
const AddLogView = lazy(() => import("../app/modules/hos/addLog/ui/main"));
const EventView = lazy(() => import("../app/modules/core/notifications/events/ui/view"));
const SettingsModuleView = lazy(() => import("../app/modules/core/settings/ui/main"));
const DriverProfileModuleView = lazy(() => import("../app/modules/core/settings/ui/driverProfile"));
const DashboardModuleView = lazy(() => import("../app/modules/dashboard/ui/main"));
const AssetsView = lazy(() => import("../app/modules/assets/ui/main"));
const SelectVehicleView = lazy(() => import("../app/modules/assets/ui/components/selectVehicle/selectVehicle"));
const TripsModuleView = lazy(() => import("../app/modules/trips/ui/main"));
const RoadSideCheckModulesView = lazy(() => import("../app/modules/hos/roadsideCheck/ui/main"));
const InspectionsModuleView = lazy(() => import("../app/modules/inspections/ui/main"));
const CreateInspectionPage = lazy(() => import("../app/modules/inspections/ui/pages/createInspection"));
const RecertifyPromptPage = lazy(() => import("../app/modules/inspections/ui/pages/recertifyPrompt"));
const InspectionDetailsPage = lazy(() => import("../app/modules/inspections/ui/pages/inspectionDetails"));
const ReviewAndCertifyPage = lazy(() => import("../app/modules/inspections/ui/pages/reviewAndCertify"));
const InspectionSubmittedPage = lazy(() => import("../app/modules/inspections/ui/pages/inspectionSubmitted"));
const InspectionHistoryDetailsPage = lazy(() => import("../app/modules/inspections/ui/pages/inspectionHistoryDetails"));
const ReportModuleView = lazy(() => import("../app/modules/hos/roadsideCheck/ui/report"));
const LockscreenModuleView = lazy(() => import("../app/modules/hos/lockscreen/ui/main"));
const HosMainModuleView = lazy(() => import("../app/modules/hos/hosMain/ui/main"));
const LoginModuleView = lazy(() => import("../app/modules/core/auth/ui/main"));
const SessionPageView = lazy(() => import("../app/modules/core/auth/ui/pages/SessionPage"));
const LogoutModuleView = lazy(() => import("../app/modules/logout/ui/main"));
const ColdChainModuleView = lazy(() => import("../app/modules/coldChain/ui/main"));
const CoachingModuleWrapper = lazy(() => import("../app/modules/coaching/ui/CoachingModuleWrapper"));

const Routes: React.FC = () => {
    return (
        <Suspense fallback={null}>
            <Switch>
                <Route path="driverSafety" component={DriverSafetyModuleView} />
                <Route path="coaching" nest component={CoachingModuleWrapper} />
                <Route path="settings/passwordChange" component={PasswordChangeModuleView} />
                <Route path="notifications/events" component={EventsModuleView} />
                <Route path="notifications/event" component={EventView} />
                <Route path="messaging/main" component={MessagingModuleView} />
                <Route path="hos/addLog" component={AddLogView} />
                <Route path="messaging/view" component={MessageViewModuleView} />
                <Route path="hos/malfunctions" component={EldMalfunctionsView} />
                <Route path="hos/lock" component={LockscreenModuleView} />
                <Route path="settings/main" component={SettingsModuleView} />
                <Route path="settings/driverProfile" component={DriverProfileModuleView} />
                <Route path="assets/main" component={AssetsView} />
                <Route path="assets/selectVehicle" component={SelectVehicleView} />
                <Route path="main" component={DashboardModuleView} />
                <Route path="inspection/main" component={RoadSideCheckModulesView} />
                <Route path="inspections/main" component={InspectionsModuleView} />
                <Route path="inspections/create" component={CreateInspectionPage} />
                <Route path="inspections/recertify" component={RecertifyPromptPage} />
                <Route path="inspections/details" component={InspectionDetailsPage} />
                <Route path="inspections/review" component={ReviewAndCertifyPage} />
                <Route path="inspections/submitted" component={InspectionSubmittedPage} />
                <Route path="inspections/historyDetails" component={InspectionHistoryDetailsPage} />
                <Route path="inspection/report" component={ReportModuleView} />
                <Route path="trips" component={TripsModuleView} />
                <Route path="hos/main" component={HosMainModuleView} />
                <Route path="login/session" component={SessionPageView} />
                <Route path="login" component={LoginModuleView} />
                <Route path="logout" component={LogoutModuleView} />
                <Route path={constants.COLD_CHAIN_ROUTE} component={ColdChainModuleView} />
            </Switch>
        </Suspense>
    );
};
export default Routes;
